import React, { useState, useEffect } from 'react';
import { PhoneIcon } from '../../Other/Icons/Icons';
import './CallButton.css';
import { useTranslation } from 'react-i18next';
import MaskedInput from 'react-text-mask';

const CallButton = () => {
  const [showText, setShowText] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const { t, i18n } = useTranslation();
  
  // Маска для номера телефона в формате +7 (999) 999-99-99
  const phoneMask = [
    '+',
    '7',
    ' ',
    '(',
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    ')',
    ' ',
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    '-',
    /[0-9]/,
    /[0-9]/,
    '-',
    /[0-9]/,
    /[0-9]/
  ];
  
  // Функция для периодического показа текста
  useEffect(() => {
    const interval = setInterval(() => {
      setShowText(true);
      
      // Скрываем текст через 3 секунды
      setTimeout(() => {
        setShowText(false);
      }, 5000);
    }, 15000); // Показываем текст каждые 15 секунд
    
    return () => clearInterval(interval);
  }, []);
  
  // Обработчик для отправки формы
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Получаем только цифры номера телефона для обработки
    const cleanNumber = phoneNumber.replace(/\D/g, '');
    
    // Проверяем, что введен полный номер телефона (11 цифр)
    if (cleanNumber.length < 11) {
      alert('Пожалуйста, введите полный номер телефона');
      return;
    }
    
    // Логика обработки номера телефона
    console.log('Номер телефона для обратного звонка:', phoneNumber);
    alert(`Мы перезвоним вам по номеру: ${phoneNumber}`);
    setPhoneNumber('');
    setIsModalOpen(false);
  };
  
  // Обработчик изменения номера телефона
  const handlePhoneChange = (e) => {
    setPhoneNumber(e.target.value);
    console.log('Ввод номера с маской:', e.target.value);
  };
  
  return (
    <>
      <div className="call-button-container">
        <button 
          className="call-button" 
          onClick={() => setIsModalOpen(true)}
          aria-label="Заказать звонок"
        >
          <PhoneIcon className="phone-icon" />
        </button>
        <div className={`call-text ${showText ? 'show' : ''}`}>
          {t('callButton')}
        </div>
      </div>
      
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button 
              className="close-button" 
              onClick={() => setIsModalOpen(false)}
            >
              &times;
            </button>
            <h2>Заказать обратный звонок</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="phone">Введите ваш номер телефона:</label>
                <MaskedInput
                  mask={phoneMask}
                  placeholderChar="_"
                  type="tel"
                  id="phone"
                  value={phoneNumber}
                  onChange={handlePhoneChange}
                  placeholder="+7 (___) ___-__-__"
                  required
                  guide={true}
                  className="phone-input"
                />
              </div>
              <button type="submit" className="submit-button">
                Позвоните мне
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default CallButton; 